// src/pages/StripeOnboardingRefresh.jsx
import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5001";

export default function StripeOnboardingRefresh() {
  const [error, setError] = useState(null);

  useEffect(() => {
    async function refreshLink() {
      try {
        const res = await axios.get(
          `${API_BASE}/api/stripe/connect/refresh`,
          { withCredentials: true }
        );

        if (res.data?.url) {
          window.location.href = res.data.url; // back to Stripe onboarding
        } else {
          setError("Could not get a new Stripe onboarding link.");
        }
      } catch (err) {
        console.error("Failed to refresh Stripe onboarding link:", err);
        setError("Something went wrong refreshing your Stripe onboarding session.");
      }
    }

    refreshLink();
  }, []);

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Refreshing Stripe onboarding…</h1>
      {error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <p>You should be redirected to Stripe in a moment.</p>
      )}
    </div>
  );
}
